import { VFooter } from 'vuetify/lib/components/VFooter';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VFooter,{staticClass:"justify-center",attrs:{"color":"white","max-width":"100vw","fixed":""}},[_c('span',[_c(VImg,{attrs:{"src":require("@/assets/esi-logo.png")}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }